import axios from 'axios';
import { TenantFeatureFlags } from '@repo/types';
import API from '../endpoints';
import { useQuery } from '@tanstack/react-query';
import { getAccessToken } from '../utils/getAccessToken';
import { useTenantConfigQuery } from './useTenantConfigQuery';

// 30 minutes frontend cache for tenant feature flags query
const CACHE_TIME = 30 * 60 * 1000;

/**
 * Shared with the web SSR prefetch (apps/web/src/utils/tenantFeatureFlagsSsr.ts): the dehydrated
 * flags only reach this hook if both sides build the same key.
 */
export const tenantFeatureFlagsQueryKey = (apiUrl: string): string[] => ['tenant-feature-flags', apiUrl];

export const useTenantFeatureFlagsQuery = () => {
  const { data: tenantConfig } = useTenantConfigQuery();
  const apiUrl = tenantConfig?.env?.apiUrl ?? '';
  const accessToken = getAccessToken();

  return useQuery({
    queryKey: tenantFeatureFlagsQueryKey(apiUrl),
    queryFn: () => fetchTenantFeatureFlags(apiUrl),
    staleTime: !accessToken ? CACHE_TIME : undefined,
    enabled: !!apiUrl,
  });
};

const fetchTenantFeatureFlags = async (apiUrl: string): Promise<TenantFeatureFlags> => {
  const { data } = await axios.get<TenantFeatureFlags>(`${apiUrl}${API.endpoints.tenantsFeatureFlags}`);
  return data;
};
